export default __webpack_public_path__ + "static/media/Map.f713f093.svg";